import { getStatusColor } from "../utils";

import { WorkflowNodeStatus } from "@/components/Workflows/types";
import { getEdgeColor } from "@/components/Workflows/utils";
import { useWorkflow } from "@/components/Workflows/WorkflowCanvas/workflow-context";

const useEdgeStyle = (node_id: string, edge_id: string, isHovering = false) => {
  const workflow = useWorkflow();
  const status = workflow.getNodeById(node_id)?.status;
  const edge = workflow.getEdge(edge_id);
  const isEdgeSelected = workflow.isEdgeSelected(edge_id);
  const edgeStatusColor = getStatusColor(edge?.status);

  // Light up edge in blue when hovering
  if (isHovering && !isEdgeSelected) {
    return "#3b82f6";
  }

  const isNotDefaultEdgeStatusColor = edgeStatusColor !== "#2563EB" && !isEdgeSelected;

  return isNotDefaultEdgeStatusColor
    ? edgeStatusColor
    : getEdgeColor(status as WorkflowNodeStatus, workflow.isEdgeSelected(edge_id));
};
export default useEdgeStyle;
